<!-- 搜索结果 - 文字结果 -->


<template>
  <div class="results-box">
    <div class="result" v-for="(item, index) in results.data">
      <a class="result_title" :href="item.webUrl" target="_blank" v-html="item.webTitleFormat">
      </a>
      <div class="result_content" v-html="item.webContentFormat">
      </div>
      <a class="result_link" :href="item.webUrl" target="_blank">
        {{item.showUrl}}
      </a>
      <div class="result_saved_button" v-if="!item.hasAction">{{item.statusDesc}}</div>
      <div class="result_save_button" v-if="item.hasAction" @click="saveEvidence(index)">存证</div>
    </div>
    <!--TextResults-->
  </div>
</template>

<style scoped>
  a{
    text-decoration: none;
    color: #000;
  }
  .results-box .result{
    width: 100%;
  }

  .result {
    margin-bottom: 24px;
  }

  .result_title {
    display: block;
    width: 95%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 1rem;
  }

  .result_content {
    width: 100%;
    overflow: hidden;
    font-size: 0.75rem;
    margin-top: 10px;
  }

  .result_link {
    display: inline-block;
    color: #2e9557;
    width: 50%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-top: 10px;
    cursor: pointer;
    font-size: 0.75rem
  }

  .result_save_button,
  .result_saved_button{
    width: 52px;
    height: 30px;
    line-height:30px;
    text-align: center;
    border-radius: 2px;
    font-size: 0.875rem;
    color: white;
    float: right;

  }

  .result_save_button {
    background-color: #A12935;
    cursor: pointer;
  }
  .result_save_button:hover{
    background-color: #c11c27;
  }
  .result_saved_button {
    background-color: #a0a0a0;
    cursor: not-allowed;
  }
  .lightRed{
    font-style: normal;
    color: #a32935;
  }

</style>

<script>
  export default  {
    name: 'TextResult',
    props: ['results'],
    mounted(){
//      this.init();
    },
    data() {
        return {

        }
    },
    methods: {
        saveEvidence(index){
            this.$emit('savingEvidence',index);
        },
//        init(){
//          let path = this.$router.currentRoute.path;
//          let keyword = typeof this.$router.currentRoute.query.keyword == 'undefined' ? '' : decodeURIComponent(this.$router.currentRoute.query.keyword);
//          this.$emit('changeChild', path.substring(path.lastIndexOf('/')+1), keyword);
//        }
    },
    watch: {
      '$route' (to, from) {
        //刷新参数放到这里里面去触发就可以刷新相同界面了
//        this.init();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TextResults.vue?4700bbc6